<template>
  <div id="stockdetail">
    <el-row style="margin: 20px auto" type="flex" justify="space-between">
      <div class="item">
        <span>
          盘库日期：{{ stockdate }}
        </span>
      </div>
      <div class="item">
        <span>
          盘库单编号：{{ stockcode }}
        </span>
      </div>
      <div class="item">
        <el-button size="medium" @click="toPrintPreview">打印盘库单</el-button>
      </div>
    </el-row>
    <div style="margin:15px 0" ref="table_print">
      <el-table :data="tableData" size="medium" stripe border>
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="PRODUCT_NAME" label="产品"></el-table-column>
        <el-table-column prop="BATCH" label="批次"></el-table-column>
        <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
        <el-table-column prop="PRODUCT_COUNT" label="库存数量"></el-table-column>
        <el-table-column prop="LOCATION_CODE" label="库位" v-if="WAREHOUSE_MODE == 2"></el-table-column>
      </el-table>
    </div>
    <!--分页-->
    <div class="pagination_box">
      <div>
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="total_count" v-show="total_count > 10">
        </el-pagination>
      </div>
      <el-row>
        <el-col :span="2" :offset="2">
          <el-button size="small" @click="entry()">盘库</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { creatStokFun } from 'api/warehouseManager';

export default {
  data() {
    return {
      stockdate: '',
      stockcode: '',
      tableData: [],
      total_count: 0,
      currentPage: 1,
      pageSize: 10,
      // 存放所有产品
      ALL_PRODUCTS: [],
      pkIdFromServer: 0,
      WAREHOUSE_MODE: sessionStorage.getItem('WAREHOUSE_MODE'),
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.querystockList();
  },
  methods: {
    querystockList() {
      const params = {
        WAREHOUSE_MODE: this.WAREHOUSE_MODE,
      };
      creatStokFun(params)
        .then((result) => {
          this.stockdate = result[0].PK_DATE;
          this.stockcode = result[0].PK_CODE;
          this.tableData = result[0].OP_ROLE;
          this.total_count = result[0].OP_ROLE.length;
          this.ALL_PRODUCTS = result[0].OP_ROLE;
          this.loadPageProducts();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    entry() {
      this.$router.push({ path: `/entryStock/${this.$route.status}`, params: { status: this.$route.status } });
    },
    // ---------------------------------分页加载当前产品
    loadPageProducts(pageIndex = 0, pageSize = this.pageSize) {
      const INDEX = pageIndex * pageSize;
      const END = INDEX + pageSize;
      if (END > this.ALL_PRODUCTS.length) {
        this.tableData = this.ALL_PRODUCTS.slice(INDEX);
      } else {
        this.tableData = this.ALL_PRODUCTS.slice(INDEX, END);
      }
    },
    // ----------------------------------页码改变时触发
    handleCurrentChange(page) {
      this.currentPage = page;
      this.loadPageProducts(page - 1);
    },
    // 打印
    toPrintPreview() {
      this.$router.push({ name: 'preview' });
    },
  },
};
</script>
<style scoped>
.pagination_box {
  width: 100%;
  display: inline-flex;
  justify-content: space-between
}
</style>



// WEBPACK FOOTER //
// src/components/warehouseManage/createStock.vue